import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryBatchListResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setBatchList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryBatchListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(async () => {
    dispatch(
      setLoading({
        key: "isBatchingListLoadingInProgress",
        status: true,
      }),
    );

    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(INVENTORY_MODULE?.BATCH_LIST?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryBatchListResponse>) => {
          if (res.data.status === true) {
            dispatch(setBatchList({ data: res.data.data }));
            dispatch(
              setLoading({
                key: "isBatchingListLoadingInProgress",
                status: false,
              }),
            );
          } else {
            dispatch(setBatchList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          dispatch(
            setLoading({
              key: "isBatchingListLoadingInProgress",
              status: false,
            }),
          );

          captureError(e);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
